import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { GetAddress } from '../../usecases/get-address'

export const useGetAddress = () => {
  const container = useContainer()
  return new GetAddress(container.get(HttpClient))
}
